(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slim"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  var videos = document.querySelectorAll('.video--autoplay');
    videos.forEach(video => {
      let video_wrapper = video.closest('.banner-slim__video');
      video.muted = true;
      video.play();
      video.setAttribute('data-state','play');
      video.setAttribute('data-state-reload','false');
      if( video_wrapper ){
        video_wrapper.setAttribute('data-state','play');
        video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state','play');
        video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state-reload','false');
        video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
      }

      if( video_wrapper ){
        let playButton = video_wrapper.querySelector('.video-play-pause');
        if( playButton ){
          playButton.addEventListener('click',function(){
            if (video.paused == true) {
              // Play the video
              video.play();
              video.setAttribute('data-state','play');
              video.setAttribute('data-state-reload','false');
              video_wrapper.setAttribute('data-state','play');

              // Update the button text to 'Pause'
              this.setAttribute('data-button-state','play');
              this.setAttribute('data-button-state-reload','false');
              video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
            } else {
              // Pause the video
              video.pause();
              video.setAttribute('data-state','pause');
              video_wrapper.setAttribute('data-state','pause');

              // Update the button text to 'Play'
              this.setAttribute('data-button-state','pause');
              video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Play video';
            }
          });
        }
      }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dto--size-guide"] && !Shopify.designMode) return;
  try {
    
      let sizeguide_buttons__gender = document.querySelectorAll('.lq--size-guide__gender-toggle__button');
      let sizeguide_buttons__unit = document.querySelectorAll('.lq--size-guide__unit-toggle__button');
      let gender_titles = document.querySelectorAll('[data-gender-title]');
  
      sizeguide_buttons__gender.forEach( gender_button => {
        gender_button.addEventListener('click',function(e){
          // console.log('gender_button',gender_button)
          sizeguide_buttons__gender.forEach( gb=> {
            gb.classList.remove('selected');
          });
          let tables = document.querySelectorAll('table.size-guide-table');
          tables.forEach( table => {
            table.setAttribute('data-gender',gender_button.getAttribute('data-gender') );
          });
          gender_titles.forEach( gender_title => {
            gender_title.setAttribute('data-gender-title',gender_button.getAttribute('data-gender'))
            gender_title.textContent = gender_button.getAttribute('data-gender')
          });
          e.target.classList.add('selected');
        });
      })
      
      sizeguide_buttons__unit.forEach( unit_button => {
        unit_button.addEventListener('click',function(e){
          sizeguide_buttons__unit.forEach( btn => {
            btn.classList.remove('selected');
          });
          let tables = document.querySelectorAll('table.size-guide-table');
          tables.forEach( table => {
            table.setAttribute('data-unit',unit_button.getAttribute('data-unit') );
          });
          e.target.classList.add('selected');
        });
      });
  
      document.getElementById('lq--size-guide--close').addEventListener('click',function(){
        document.getElementById('lq--size-guide').close();
      });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature--carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {

      let quickViewButtons = document.querySelectorAll('.feature-contentblocks__block__quickview');
      quickViewButtons.forEach(z => {
          z.addEventListener('click',function(e){
              let product_id;
              if( e.target.tagName === 'BUTTON'){
                  product_id = e.target.getAttribute('data-product-id');
              }else{
                  product_id = e.target.closest('button').getAttribute('data-product-id');
              }
              if(!product_id) return;
              // window.$triggerQuickViewModal(product_id);
              let tile = e.target.closest('.feature-carousel__image-container');
              tile.querySelector('.card__inner .quick-add__submit').click();

          })
      });

      var videos = document.querySelectorAll('.video--autoplay');
      videos.forEach(video => {
        let video_wrapper = video.closest('.feature-carousel__image');
        video.muted = true;
        video.play();
        video.setAttribute('data-state','play');
        video.setAttribute('data-state-reload','false');
        if( video_wrapper ){
          video_wrapper.setAttribute('data-state','play');
          video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state','play');
          video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state-reload','false');
          video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
        }

        if( video_wrapper ){
          let playButton = video_wrapper.querySelector('.video-play-pause');
          if( playButton ){
            playButton.addEventListener('click',function(){
              if (video.paused == true) {
                // Play the video
                video.play();
                video.setAttribute('data-state','play');
                video.setAttribute('data-state-reload','false');
                video_wrapper.setAttribute('data-state','play');

                // Update the button text to 'Pause'
                this.setAttribute('data-button-state','play');
                this.setAttribute('data-button-state-reload','false');
                video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
              } else {
                // Pause the video
                video.pause();
                video.setAttribute('data-state','pause');
                video_wrapper.setAttribute('data-state','pause');

                // Update the button text to 'Play'
                this.setAttribute('data-button-state','pause');
                video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Play video';
              }
            });
          }
        }
      });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature--content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
      let quickViewButtons = document.querySelectorAll('.feature-contentblocks__block__quickview');
      quickViewButtons.forEach(z => {
          z.addEventListener('click',function(e){
              let product_id;
              if( e.target.tagName === 'BUTTON'){
                  product_id = e.target.getAttribute('data-product-id');
              }else{
                  product_id = e.target.closest('button').getAttribute('data-product-id');
              }
              if(!product_id) return;
              // window.$triggerQuickViewModal(product_id);
              let tile = e.target.closest('.feature-contentblocks__block');
              tile.querySelector('.pdp-feature-contentblocks__content__product-tile .quick-add__submit').click();

          })
      })
      var videos = document.querySelectorAll('.video--autoplay');
      videos.forEach(video => {
        let video_wrapper = video.closest('.feature-contentblocks__image');
        video.muted = true;
        video.play();
        video.setAttribute('data-state','play');
        video.setAttribute('data-state-reload','false');
        if( video_wrapper ){
          video_wrapper.setAttribute('data-state','play');
          video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state','play');
          video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state-reload','false');
          video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
        }

        if( video_wrapper ){
          let playButton = video_wrapper.querySelector('.video-play-pause');
          if( playButton ){
            playButton.addEventListener('click',function(){
              if (video.paused == true) {
                // Play the video
                video.play();
                video.setAttribute('data-state','play');
                video.setAttribute('data-state-reload','false');
                video_wrapper.setAttribute('data-state','play');

                // Update the button text to 'Pause'
                this.setAttribute('data-button-state','play');
                this.setAttribute('data-button-state-reload','false');
                video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
              } else {
                // Pause the video
                video.pause();
                video.setAttribute('data-state','pause');
                video_wrapper.setAttribute('data-state','pause');

                // Update the button text to 'Play'
                this.setAttribute('data-button-state','pause');
                video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Play video';
              }
            });
          }
        }
      });

  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature--cross-promo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  var videos = document.querySelectorAll('.video--autoplay');
    videos.forEach(video => {
      let video_wrapper = video.closest('.feature-crosspromo__video');
      video.muted = true;
      video.play();
      video.setAttribute('data-state','play');
      video.setAttribute('data-state-reload','false');
      if( video_wrapper ){
        video_wrapper.setAttribute('data-state','play');
        video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state','play');
        video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state-reload','false');
        video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
      }

      if( video_wrapper ){
        let playButton = video_wrapper.querySelector('.video-play-pause');
        if( playButton ){
          playButton.addEventListener('click',function(){
            if (video.paused == true) {
              // Play the video
              video.play();
              video.setAttribute('data-state','play');
              video.setAttribute('data-state-reload','false');
              video_wrapper.setAttribute('data-state','play');

              // Update the button text to 'Pause'
              this.setAttribute('data-button-state','play');
              this.setAttribute('data-button-state-reload','false');
              video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
            } else {
              // Pause the video
              video.pause();
              video.setAttribute('data-state','pause');
              video_wrapper.setAttribute('data-state','pause');

              // Update the button text to 'Play'
              this.setAttribute('data-button-state','pause');
              video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Play video';
            }
          });
        }
      }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature--hero-multi-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var multivideos = document.querySelectorAll('.video--autoplay-hero');
  console.log('multivideos',multivideos)
  multivideos.forEach(video => {
        let video_wrapper = video.closest('.video--autoplay-hero--container');
        video.muted = true;
        video.play();
        video.setAttribute('data-state','play');
        video.setAttribute('data-state-reload','false');
        if( video_wrapper ){
          video_wrapper.setAttribute('data-state','play');
          video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state','play');
          video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state-reload','false');
          video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
        }

        if( video_wrapper ){
          let playButton = video_wrapper.querySelector('.video-play-pause');
          if( playButton ){
            playButton.addEventListener('click',function(){
              if (video.paused == true) {
                // Play the video
                video.play();
                video.setAttribute('data-state','play');
                video.setAttribute('data-state-reload','false');
                video_wrapper.setAttribute('data-state','play');

                // Update the button text to 'Pause'
                this.setAttribute('data-button-state','play');
                this.setAttribute('data-button-state-reload','false');
                video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
              } else {
                // Pause the video
                video.pause();
                video.setAttribute('data-state','pause');
                video_wrapper.setAttribute('data-state','pause');

                // Update the button text to 'Play'
                this.setAttribute('data-button-state','pause');
                video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Play video';
              }
            });
          }
        }
      });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature--hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var videos = document.querySelectorAll('.video--autoplay');
  videos.forEach(video => {
    video.muted = true;
    video.play();
  })
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature--tabbed-collection"] && !Shopify.designMode) return;
  try {
    
    let nextButtons = document.querySelectorAll('.scroll-next');
    let prevButtons = document.querySelectorAll('.scroll-prev');
    
    let collections = document.querySelectorAll('.feature-tabbed-collection__collection');
    
    collections.forEach( (collection) => {
        collection.addEventListener('scroll', () => {
            // console.log('Current X Position:', collection.scrollLeft);
            // console.log('collection - clientWidth',collection.clientWidth)
            // console.log('collection - scrollWidth',collection.scrollWidth)
            let tab_content = collection.closest('.feature-tabbed-collection__tabs__tab-content');
            
            if( ( collection.scrollLeft + 100 ) > (collection.scrollWidth - collection.clientWidth) ){
                tab_content.querySelector('.scroll-next').setAttribute('disabled','disabled');
                tab_content.querySelector('.scroll-prev').removeAttribute('disabled');
                // console.log('cannot go further')
            }else if( collection.scrollLeft < 100 ) {
                // console.log('back to start')
                tab_content.querySelector('.scroll-next').removeAttribute('disabled');
                tab_content.querySelector('.scroll-prev').setAttribute('disabled','disabled');
            }else{
                tab_content.querySelector('.scroll-prev').removeAttribute('disabled');
                tab_content.querySelector('.scroll-next').removeAttribute('disabled');
            }
        });
    });
    
    
    nextButtons.forEach( (el) => {
        el.addEventListener('click',function(){
            let parent = el.closest('.feature-tabbed-collection__tabs__tab-content');
            parent.querySelector('.feature-tabbed-collection__collection').scrollLeft += 300
        })
    });
    prevButtons.forEach( (el) => {
        el.addEventListener('click',function(){
            let parent = el.closest('.feature-tabbed-collection__tabs__tab-content');
            parent.querySelector('.feature-tabbed-collection__collection').scrollLeft -= 300
        })
    });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-page-link"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("load", (event) => {
    let sizeSwatchesContainer = document.querySelector('.product-form__option1');

    let swatches = sizeSwatchesContainer.querySelectorAll('.option-select__label');

    let list = sizeSwatchesContainer.querySelector('.option-select__label-list');
    // list.classList.add('soldout');
    console.log('list',list)
    console.log('swatches',swatches)

    if ( Array.from(swatches).every(child => child.classList.contains("option-select__label--out-of-stock"))) {
        let currentProdId = list.closest('.product-display-wrapper').getAttribute('data-current-pseudo-variant-product-id');
        if( currentProdId == '8261435359347' ){
            list.classList.add('soldout');
            let soldoutBox = document.createElement('div');
            soldoutBox.innerHTML = 'This exclusive product has sold out, <u>sign up to get early access</u> to future OOFOS collabs';
            soldoutBox.classList.add('soldoutbox');
            list.append(soldoutBox);

            soldoutBox.addEventListener('click', function (){
                window._klOnsite = window._klOnsite || []; 
                window._klOnsite.push(['openForm', 'Tpytwk']);
            }); 
        }   
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-image"] && !Shopify.designMode) return;
  try {
    
if( document.getElementById('form--image-side') ){

	if( document.getElementById('custom-thank-you-message') ){
		let thankYou = document.getElementById('custom-thank-you-message');
		if( thankYou.querySelector('a[href="mailto:team@oofos.com"]') || window.location.href.indexOf("team-sales") > -1) {
			document.body.classList.add('template-page--forms--team-sales');
		}else{
			document.body.classList.add('template-page--forms--corporate-sales');
		}
	}
}
window.addEventListener('load',async function(){

	var hasBeenShifted = false;

    async function getTextFromForm(){
		if( hasBeenShifted ) return;
        let form = document.getElementById('app-embed');
        if(!form) return;
        let formShadowRoot = form.shadowRoot;
        if( !formShadowRoot ) return;

        let text = formShadowRoot.querySelector('[class^="_formHeader_"]').innerHTML;
        if( !text ) return;
        formShadowRoot.querySelector('[class^="_formHeader_"]').style.display = 'none';
        return text;
    }

    async function replaceText(html){
		if( hasBeenShifted ) return;
		// get the image
		let image = document.getElementById('form--image-side__figure');
		let newImage = image.cloneNode(true);
		newImage.id = 'form--image-side__figure-2';
		let form = document.getElementById('app-embed');
		if(!form) return;
        let formShadowRoot = form.shadowRoot;
        if( !formShadowRoot ) return;

		let form_element = formShadowRoot.querySelector('section[data-sizing="form-wrapper"][role="dialog"] [class^="_formHeader_"]');
		return form_element.append(newImage);
    }

	async function injectShadowStyles(){
		if( hasBeenShifted ) return;
		let form = document.getElementById('app-embed');
		if(!form) return;
        let formShadowRoot = form.shadowRoot;
        if( !formShadowRoot ) return;

		var styleSheet = new CSSStyleSheet;
		styleSheet.replaceSync(`
				#app-embed #form-container-ref section[data-sizing="form-wrapper"][role="dialog"]{
					padding: 20px;
					color: #fff;
					width: calc(100% - 40px);
					margin-top: 1.5rem;
					max-width: 100%;
				}
				#app-embed #form-container-ref section[data-sizing="form-wrapper"][role="dialog"] form {
					max-width: 100%;
					background: #fff;
					padding: 20px;
					border-radius: 16px 16px 0 0;
					overflow: hidden;
				}
				#app-embed #form-container-ref section[data-sizing="form-wrapper"][role="dialog"] [class*="formDisclaimer"] {
					border-radius: 0 0 16px 16px;
					background: #fff;
					margin-top: 0 !important;
					padding-bottom: 24px;
				}
				#app-embed[data-current-step="success"] section[data-sizing="form-wrapper"][role="dialog"] {
					max-width: calc(100% - 40px);
				}
				
				@media screen and (min-width:1024px) {
					#app-embed #form-container-ref section[data-sizing="form-wrapper"][role="dialog"],
					#app-embed[data-current-step="success"] section[data-sizing="form-wrapper"][role="dialog"]{
						max-width: calc(100% - 80px);
					}
					#app-embed[data-current-step="success"] section[data-sizing="form-wrapper"][role="dialog"] {
						margin-top: 3rem;
					}
				}
				@media screen and (min-width:1680px) {
					#app-embed #form-container-ref section[data-sizing="form-wrapper"][role="dialog"],
					#app-embed[data-current-step="success"] section[data-sizing="form-wrapper"][role="dialog"]{
						max-width: 740px;
					}
				}
				#app-embed #form-container-ref section[data-sizing="form-wrapper"][role="dialog"] fieldset label,
				#app-embed #form-container-ref section[data-sizing="form-wrapper"][role="dialog"] fieldset span,
				#app-embed #form-container-ref section[data-sizing="form-wrapper"][role="dialog"] p {
					color:#202020;
				}
				#app-embed #form-container-ref section[data-sizing="form-wrapper"][role="dialog"] > div, {
					width: 100%;
					margin: 0 auto;
				}
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section {
					text-align: left;
					align-items: flex-start;
				}
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] [data-testid="banner-success"] h2,
				#app-embed #form-container-ref section[data-sizing="form-wrapper"][role="dialog"] h2 {
					font-family: Helvetica Neue Pro Ex,Arial,sans-serif;
					display: block;
					font-size: 2.125rem;
					line-height: 2.5rem;
        			letter-spacing: .04375rem;
					text-transform: uppercase;
					color: #fff;
				}
				#app-embed #form-container-ref section[data-sizing="form-wrapper"][role="dialog"] h2 + div p {
					color: #fff;
				}
				#app-embed #form-container-ref section[data-sizing="form-wrapper"][role="dialog"] h2::before {
					content: '';
					display: block;
					width: 120px;
					height: 20px;
					background-size: contain;
					background-position: center center;
					position:relative;
					margin-bottom: 8px;
					background-image: url("data:image/svg+xml,%3Csvg width='102' height='17' viewBox='0 0 102 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_3168_8718)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M100.601 15.7853H100.326L99.9166 15.3444H99.7159V15.7861H99.5127V14.6484H99.8977C99.9758 14.6484 100.039 14.6517 100.089 14.6591C100.141 14.6656 100.191 14.6818 100.237 14.7068C100.289 14.7348 100.328 14.7694 100.352 14.8097C100.376 14.85 100.389 14.9002 100.389 14.961C100.391 15.034 100.366 15.1052 100.319 15.1609C100.266 15.2185 100.2 15.2622 100.126 15.2884L100.601 15.7853ZM100.166 14.9742C100.166 14.9469 100.16 14.9198 100.149 14.8952C100.136 14.8703 100.115 14.8501 100.09 14.8376C100.065 14.8235 100.037 14.8143 100.009 14.8105C99.9727 14.8058 99.9364 14.8036 99.9001 14.8039H99.7159V15.1881H99.8738C99.918 15.1888 99.9621 15.1849 100.005 15.1765C100.039 15.1701 100.07 15.156 100.097 15.1354C100.12 15.118 100.139 15.0947 100.15 15.068C100.162 15.0381 100.167 15.0062 100.166 14.9742Z' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M100.715 14.4801C100.618 14.3784 100.501 14.2979 100.371 14.2435C100.241 14.1892 100.101 14.1622 99.9603 14.1642C99.665 14.1642 99.4133 14.2695 99.2052 14.4801C99.104 14.5788 99.0239 14.6971 98.97 14.8278C98.9161 14.9585 98.8895 15.0988 98.8918 15.2402C98.8918 15.5363 98.9963 15.7905 99.2052 16.0011C99.4133 16.2109 99.665 16.3162 99.9603 16.3162C100.255 16.3162 100.507 16.2109 100.715 16.0011C100.924 15.7905 101.03 15.5372 101.03 15.2402C101.03 14.9441 100.924 14.6899 100.715 14.4801ZM100.615 15.9016C100.531 15.9904 100.429 16.0607 100.317 16.1083C100.204 16.1559 100.083 16.1796 99.9603 16.178C99.7045 16.178 99.4873 16.0858 99.3064 15.9016C99.2188 15.8154 99.1496 15.7123 99.103 15.5987C99.0563 15.485 99.0332 15.3631 99.0349 15.2402C99.0349 14.9836 99.1254 14.7631 99.3064 14.5788C99.4873 14.3946 99.7045 14.3024 99.9603 14.3024C100.216 14.3024 100.433 14.3946 100.615 14.5788C100.795 14.7623 100.886 14.9836 100.886 15.2402C100.886 15.4977 100.795 15.7173 100.615 15.9016ZM50.6414 6.60374H59.9146V9.82586H50.6414V16.3162H46.7818V4.01749C46.7818 1.8705 48.5117 0.129883 50.6455 0.129883H59.9146V3.35118H52.1476C51.9491 3.35194 51.7528 3.39177 51.5697 3.46841C51.3867 3.54505 51.2205 3.65699 51.0808 3.79784C50.941 3.9387 50.8303 4.10571 50.7551 4.28933C50.6798 4.47296 50.6415 4.66961 50.6422 4.86805V6.60374M94.1224 6.60374C96.0744 6.60785 97.9154 7.95527 98.5282 10.0825C98.6631 10.5514 98.7281 11.0227 98.7322 11.4842V11.7474C98.7338 13.7743 97.5197 15.6005 95.6252 16.1533C95.2581 16.2606 94.8775 16.3154 94.495 16.3162H84.5884V13.0949H94.2128C94.3329 13.0973 94.4547 13.0817 94.5756 13.0455C95.1161 12.8884 95.4714 12.3792 95.4953 11.805L95.4961 11.3362C95.5001 11.1805 95.4801 11.0251 95.4369 10.8755C95.2542 10.2437 94.7089 9.8275 94.1306 9.82586H89.4985C87.4206 9.83737 85.4563 8.35752 84.8048 6.09373C84.6704 5.63177 84.5977 5.1541 84.5884 4.6731C84.5967 2.65526 85.8083 0.843899 87.6946 0.29358C88.0616 0.185647 88.4422 0.130528 88.8248 0.129883H97.8981V3.352H89.107C88.9846 3.34932 88.8625 3.36541 88.745 3.39971C88.2112 3.55601 87.8591 4.05121 87.8245 4.61552L87.8237 5.0844C87.8188 5.24069 87.8369 5.40027 87.8829 5.55904C88.0647 6.18997 88.6109 6.60292 89.1909 6.60374H94.1224ZM11.6527 0.129883H9.65788C7.23121 0.129883 0.00878906 1.63524 0.00878906 8.22344C0.00878906 14.81 7.23121 16.3162 9.65788 16.3162H11.6527C14.0818 16.3162 21.3034 14.8108 21.3034 8.22344C21.3034 1.63606 14.081 0.129883 11.6527 0.129883ZM11.3269 12.6219H9.98445C8.34912 12.6219 3.48756 11.8034 3.48756 8.22344C3.48756 4.64266 8.34912 3.82417 9.98445 3.82417H11.3269C12.9623 3.82417 17.8238 4.64266 17.8238 8.22344C17.8238 11.8034 12.9623 12.6219 11.3269 12.6219ZM34.6822 0.129883H32.6874C30.2607 0.129883 23.0383 1.63524 23.0383 8.22344C23.0383 14.81 30.2607 16.3162 32.6874 16.3162H34.6822C37.1105 16.3162 44.3329 14.8108 44.3329 8.22344C44.3329 1.63606 37.1113 0.129883 34.6822 0.129883ZM34.3564 12.6219H33.0123C31.3786 12.6219 26.5162 11.8034 26.5162 8.22344C26.5162 4.64266 31.3786 3.82417 33.0123 3.82417H34.3564C35.9909 3.82417 40.8533 4.64266 40.8533 8.22344C40.8533 11.8034 35.9917 12.6219 34.3564 12.6219ZM73.3855 0.129883H71.3898C68.9632 0.129883 61.7407 1.63524 61.7407 8.22344C61.7407 14.81 68.9632 16.3162 71.3898 16.3162H73.3855C75.8121 16.3162 83.0354 14.8108 83.0354 8.22344C83.0354 1.63606 75.8129 0.129883 73.3855 0.129883ZM73.0589 12.6219H71.7156C70.0811 12.6219 65.2195 11.8034 65.2195 8.22344C65.2195 4.64266 70.0811 3.82417 71.7156 3.82417H73.0589C74.6942 3.82417 79.5558 4.64266 79.5558 8.22344C79.5558 11.8034 74.6942 12.6219 73.0589 12.6219Z' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M28.3271 9.36994H39.044V7.05762H28.3271V9.36994Z' fill='%2399C13F'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_3168_8718'%3E%3Crect width='101.161' height='16.5161' fill='white' transform='translate(0.00878906)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
				}
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] p {
					color: #fff;
				}
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section p a {
					display: block;
					background: #fff;
    				padding: 8px 32px 12px 32px;
    				border-radius: 4px;
					color: #202020;
					text-decoration: none;
					margin-top: 30px;
					max-width: max-content;
				}
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section #custom-thank-you-message-cloned p a {
					display: inline;
					background: transparent;
    				padding: 0;
    				border-radius: 0;
					color: currentColor;
					text-decoration: underline;
					margin-top: 0;
					max-width: max-content;
				}
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section #custom-thank-you-message-cloned p,
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section #custom-thank-you-message-cloned span,
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section #custom-thank-you-message-cloned ul, 
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section #custom-thank-you-message-cloned ul li,
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section #custom-thank-you-message-cloned h1,
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section #custom-thank-you-message-cloned h2,
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section #custom-thank-you-message-cloned h3,
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section #custom-thank-you-message-cloned h4,
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section #custom-thank-you-message-cloned h5,
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section #custom-thank-you-message-cloned h6 {
					color: #fff;
				}
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section #custom-thank-you-message-cloned img {
				    width: 100%;
    				object-fit: contain;
    				height: auto;
    				border-radius: 20px;
					margin-top: 0.5rem;
				}
				#app-embed section[data-sizing="form-wrapper"][role="dialog"] > div > section #custom-thank-you-message-cloned p {
				margin-bottom: 1rem;
				}
				@media screen and (min-width: 1024px){
					section[data-sizing="form-wrapper"][role="dialog"] [class^="_formHeader_"] .form--image-side__figure {
						display: none;
					}
				}
				section[data-sizing="form-wrapper"][role="dialog"] [class^="_formHeader_"] .form--image-side__figure {
					width:100%;
					overflow:hidden;
					border-radius:16px;
					margin:1.5rem auto;
				}
				section[data-sizing="form-wrapper"][role="dialog"] [class^="_formHeader_"] .form--image-side__figure img {
					object-fit: cover;

					width: 100%;
					height: 100%;
				}
				[aria-controls="custom#type_of_team-selector-dropdown"] > span:first-child:empty::after {
					content:'Type of Team';
					display: block;
					opacity: 0.5;
				}
				[class*=_selectContainer]:has([aria-controls="custom#type_of_team-selector-dropdown"]) p[class^="_label"] {
					display:none;
				}
				[class^="_dropdownContainer_"] {
					box-shadow: 0 0 10px rgba(0,0,0,0.333);
					max-width: calc( 100% - 8px );
					margin-left: 4px;
					margin-right: auto;
					border: 1px solid #20202033;
				}
			`);

		formShadowRoot.adoptedStyleSheets.push(styleSheet)

		if( intervalId ){
			clearInterval(intervalId);
		}

		return hasBeenShifted = true;
	}


	// check if it has been done already

	const intervalId = setInterval( async() => {
		// let theText = await getTextFromForm();
		await replaceText();
		await injectShadowStyles();
	}, 1000);

    // let theText = await getTextFromForm();
    await replaceText();
	await injectShadowStyles();



/**
 * Wait for an element to be added to the DOM or shadow DOM.
 * @param {ShadowRoot | Document} root - The root to observe.
 * @param {string} selector - The selector of the element to wait for.
 * @param {number} [timeout] - The time in milliseconds to wait before rejecting the promise.
 * @returns {Promise<HTMLElement | Node>} - A promise that resolves with the element when it is added to the DOM or shadow DOM.
 */
async function waitForElement(root, selector, timeout = 1200000) {
  return new Promise((resolve, reject) => {
    let element = root.querySelector(selector);
    if (element) {
      resolve(element);
    } else {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.matches(selector)) {
                  observer.disconnect();
                  clearTimeout(timeoutId); // Clear the timeout
                  resolve(node);
                } else if (node.shadowRoot) {
                  const shadowElement = node.shadowRoot.querySelector(selector);
                  if (shadowElement) {
                    observer.disconnect();
                    clearTimeout(timeoutId); // Clear the timeout
                    resolve(shadowElement);
                  } else {
                    observer.observe(node.shadowRoot, { childList: true, subtree: true });
                  }
                }
                element = root.querySelector(selector);
                if (element) {
                  observer.disconnect();
                  clearTimeout(timeoutId); // Clear the timeout
                  resolve(element);
                }
              }
            });
          }
        });
      });

      observer.observe(root, { childList: true, subtree: true });

      // Set a timeout to reject the promise if the element is not found within 1 second
      const timeoutId = setTimeout(() => {
        observer.disconnect(); // Stop observing when the timeout expires
        reject(new Error("Element not found"));
		if(!alert('Your session has expired. The window will now refresh to restart your session.')){window.location.reload();}
      }, timeout);
    }
  });
}
let form = document.getElementById('app-embed');
if(!form) return;
let formShadowRoot = form.shadowRoot;
// let isEl = await waitForElement(formShadowRoot,'._textBody_2aowh_10').then( z => {
let isEl = await waitForElement(formShadowRoot,'[data-testid="banner-success"]').then( z => {
	let newContent = document.getElementById('custom-thank-you-message').cloneNode(true);
	newContent.id = 'custom-thank-you-message-cloned';
	newContent.style.display = 'block';
	z.innerHTML = '';
	z.appendChild( newContent );
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero--slider"] && !Shopify.designMode) return;
  try {
    
function advanceToDot(button) {
   
    let pagination_index = button.getAttribute('data-pagination-index');
    if( pagination_index == '1' ){
        pagination_index = 0;
    }
    let carousel = button.closest('.hero-carousel--outer');
    let carouselItemWidth = carousel.querySelectorAll('.hero-carousel')[0].clientWidth;
    carousel.scrollLeft = carouselItemWidth * pagination_index;
}
document.addEventListener("DOMContentLoaded", function() {
  var videos = document.querySelectorAll('.video--autoplay');
  if( videos ){
      videos.forEach(video => {
        video.muted = true;
        video.play();
        let video_wrapper = video.closest('.hero-carousel__video');
        video.setAttribute('data-state','play');
        video.setAttribute('data-state-reload','false');
        if( video_wrapper ){
          video_wrapper.setAttribute('data-state','play');
          video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state','play');
          video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state-reload','false');
          video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';

          let playButton = video_wrapper.querySelector('.video-play-pause');
          if( playButton ){
            playButton.addEventListener('click',function(){
              if (video.paused == true) {
                // Play the video
                video.play();
                video.setAttribute('data-state','play');
                video.setAttribute('data-state-reload','false');
                video_wrapper.setAttribute('data-state','play');

                // Update the button text to 'Pause'
                this.setAttribute('data-button-state','play');
                this.setAttribute('data-button-state-reload','false');
                video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
              } else {
                // Pause the video
                video.pause();
                video.setAttribute('data-state','pause');
                video_wrapper.setAttribute('data-state','pause');

                // Update the button text to 'Play'
                this.setAttribute('data-button-state','pause');
                video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Play video';
              }
            });
          }
        }
      })
  }
  var carousels = document.querySelectorAll('.hero-carousel--outer');
  if( carousels ){
    carousels.forEach( carousel => {
        let dots = carousel.querySelectorAll('.hero-carousel--nav__pagination-dot');
        dots.forEach(dot => {
            dot.addEventListener('click',function(e){
                advanceToDot(e.target);
            });
        });

        carousel.addEventListener('scrollsnapchange', () => {
            let carousel_item = carousel.querySelectorAll('.hero-carousel')[0];
            let carousel_item__width = carousel_item.clientWidth;
            let scroll_over_width = carousel.scrollLeft / carousel.clientWidth;
            let index = Math.round(carousel.scrollLeft / carousel_item__width);

            let pagination_dots = carousel.querySelectorAll('.hero-carousel--nav__pagination-dot');
            let the_nav = carousel.querySelector('.hero-carousel--nav');
            
                if( index || index === 0 ) {
                    index = index + 1;
                    pagination_dots.forEach(dot => {
                        let currentIndex;
                        if( dot.getAttribute('data-pagination-index') ){
                            currentIndex = Number( dot.getAttribute('data-pagination-index') );
                        }
                        the_nav.setAttribute('data-current-slide',index)
                        if( currentIndex && currentIndex === index ) {
                            // pagination_dots[currentIndex].classList.add('selected');
                            // console.log('pagination_dots[currentIndex]',pagination_dots[currentIndex])
                            // pagination_dots[currentIndex].setAttribute('data-is-selected','true');
                            // alert('index: '+index)
                        }else{
                            // dot.classList.remove('selected');
                            // dot.setAttribute('data-is-selected','false');
                        }
                    });
                }
        });
    });
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage--solution-selling"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', async function () {
    await getYotpoData();
});
async function getYotpoData(){
    const total_review_count = document.getElementById('total-reviews-count');
    const average_star_count = document.getElementById('average-star-count');
    if( !total_review_count && !average_star_count ){
        return;
    }
    let yotpoData = sessionStorage.getItem('yotpoData');
    if( !yotpoData ){
        yotpoData = await fetch('https://api-cdn.yotpo.com/v3/storefront/store/W1pdhC99O27k6bEf7xAOpqmjKE6A5llmtdyUuQ1Z/reviews?page=1&perPage=10')
            .then( 
                response => response.json() )
            .then( data => {
                var fetchedYotpoData;
                if ( data && data.bottomline && data.bottomline.averageScore && data.bottomline.totalReview ) {
                    fetchedYotpoData = {averageScore: data.bottomline.averageScore, totalReviews: data.bottomline.totalReview };
                }else{
                    fetchedYotpoData = {averageScore: 4.5, totalReviews: 208058};
                }
                return JSON.stringify(fetchedYotpoData);
            });
    }else{
        yotpoData = JSON.parse(yotpoData);
    }
    sessionStorage.setItem('yotpoData',yotpoData);
    yotpoData = JSON.parse(yotpoData);
    average_star_count.textContent = Math.round(yotpoData.averageScore * 10) / 10;
    average_star_count.setAttribute('data-star-count',yotpoData.averageScore)
    total_review_count.textContent = yotpoData.totalReviews.toLocaleString();
    total_review_count.setAttribute('data-review-count',yotpoData.totalReviews);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty--3up"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", async () => {
    document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
    async function getRediemUserSessionStorage(){
        let userData = sessionStorage.getItem('user_www.oofos.com');
        if( !userData ) return;
        let userDataJSON = JSON.parse(userData);
        return userDataJSON;
    }
    async function getBearerToken(){
        let userDataJSON = await getRediemUserSessionStorage()
        if( !userDataJSON.data || !userDataJSON.data.token ) return;
        return userDataJSON.data.token;
    }
    async function getRediemTierData(token){
        let data = await fetch('https://api.rediem.io/api/dash/tiers', { 
            method: 'GET', 
            headers: new Headers({
                'Authorization': 'Bearer '+token, 
                'Content-Type': 'application/json'
            }),
        }).then( response => {
            return response.json();
        });
        if( data && data.success == true) {
            return data;
        }else{
            return;
        }
    }
    async function getCurrentUserTier(rediemTierData) {
        let userData = await getRediemUserSessionStorage();
        let userTierId = userData.data.activeTier;
        if( !userTierId ) return;

        let rediemTiers = rediemTierData.data.tiers;

        let currentTierName;
        let currentTierIndex;
        rediemTiers.forEach( (tier,index) => {
            if( tier._id === userTierId ) {
                currentTierName = tier.name
                currentTierIndex = index;
            }
        });
        if( currentTierName ) {
            return {index: currentTierIndex, name: currentTierName.toUpperCase()};
        }
    }
    async function unlockUserTiers(currentUserTier){
        if( !currentUserTier.name ){
            return;
        }
        if( currentUserTier.name === 'MEMBER' ) {
            document.querySelector('[data-loyalty-tier="MEMBER"]').classList.add('unlocked');
        }
        if( currentUserTier.name === 'INSIDER' ) {
            document.querySelector('[data-loyalty-tier="MEMBER"]').classList.add('unlocked');
            document.querySelector('[data-loyalty-tier="INSIDER"]').classList.add('unlocked');
        }
        if( currentUserTier.name === 'AMBASSADOR' ) {
            document.querySelector('[data-loyalty-tier="MEMBER"]').classList.add('unlocked');
            document.querySelector('[data-loyalty-tier="INSIDER"]').classList.add('unlocked');
            document.querySelector('[data-loyalty-tier="AMBASSADOR"]').classList.add('unlocked');
        }
    }
    let rediemToken = await getBearerToken();
    let rediemTierData;
    let currentUserTier;
    if( rediemToken ){
        let rediemTierData = await getRediemTierData(rediemToken);
        let currentUserTier = await getCurrentUserTier(rediemTierData);    
    }
    // await unlockUserTiers(currentUserTier);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty--how-it-works"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  ScrollTrigger.defaults({
  markers:false
})

var points = gsap.utils.toArray('.point');
// console.log('points',points)
var indicators = gsap.utils.toArray('.indicator');
// console.log('indicators',indicators)

var height = 100 * points.length;

// console.log('height',height)

gsap.set('.indicators', {display: "flex"});

var tl = gsap.timeline({
  scrollTrigger: {
    trigger: ".loyalty-howitworks",
    start: "top top",
    end: "+="+height+"%",
    scrub: true,
    id: "points",
    snap: "labelsDirectional",
    markers: false
  }
})

ScrollTrigger.create({
    trigger: ".loyalty-howitworks .wrapper",
    start: "-60px top",
    end: "+="+height+"%",
    scrub: true,
    pin: ".loyalty-howitworks .wrapper",
    pinSpacing: true,
    id: "pinning",
    markers: false
})

points.forEach(function(elem, i) {
  gsap.set(elem, {position: "absolute", top: 0});
    if (i == 0) {
        tl.to(indicators[i], {backgroundColor: "#c7c7c7", duration: 0.25}, i)
        tl.from(elem.querySelectorAll('img'), {autoAlpha:1}, i)
        tl.from(elem.querySelector('.sub-step:first-child'), {autoAlpha:1}, i)
    }else{
        tl.to(indicators[i], {backgroundColor: "#c7c7c7", duration: 0.25}, i)
        tl.from(elem.querySelectorAll('img'), {autoAlpha:0}, i)
        tl.from(elem.querySelectorAll('.sub-step'), {autoAlpha:0}, i)
    }
    tl.add("label" + i);
    
    if (i != points.length-1) {
        tl.to(indicators[i], {backgroundColor: "#c7c7c7", duration: 0.25}, i+0.75)
        tl.to(elem.querySelectorAll('img'), {autoAlpha:0}, i + 0.75)
        tl.to(elem.querySelectorAll('.sub-step'), {autoAlpha:0}, i + 0.75)
    }
});


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty--two-up-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", async () => {
    let colorElement = document.querySelector('[data-new-nav-bg-color]');
    let color;
    if( colorElement ){
        color = colorElement.getAttribute('data-new-nav-bg-color');
        document.querySelector('.navbar-desktop__wrapper').style.setProperty('background-color', color);
    }

    document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
    async function getRediemUserSessionStorage(){
        let userData = sessionStorage.getItem('user_www.oofos.com');
        if( !userData ) return;
        let userDataJSON = JSON.parse(userData);
        return userDataJSON;
    }
    async function getBearerToken(){
        let userDataJSON = await getRediemUserSessionStorage()
        if( !userDataJSON || !userDataJSON.data || !userDataJSON.data.token ) return;
        return userDataJSON.data.token;
    }
    async function getRediemTierData(token){
        let data = await fetch('https://api.rediem.io/api/dash/tiers', { 
            method: 'GET', 
            headers: new Headers({
                'Authorization': 'Bearer '+token, 
                'Content-Type': 'application/json'
            }),
        }).then( response => {
            return response.json();
        });
        if( data && data.success == true) {
            return data;
        }else{
            return;
        }
    }
    async function getCurrentUserTier(rediemTierData) {
        let userData = await getRediemUserSessionStorage();
        let userTierId = userData.data.activeTier;
        if( !userTierId ) return;

        let rediemTiers = rediemTierData.data.tiers;

        let currentTierName;
        let currentTierIndex;
        rediemTiers.forEach( (tier,index) => {
            if( tier._id === userTierId ) {
                currentTierName = tier.name
                currentTierIndex = index;
            }
        });
        if( currentTierName ) {
            return {index: currentTierIndex, name: currentTierName.toUpperCase()};
        }
    }
    async function getCurrentUserData(){
        return await getRediemUserSessionStorage();
    }
    let rediemToken = await getBearerToken();
    let rediemTierData;
    let currentUserTier;
    if( !rediemToken ) {
        
    }else{
        let rediemTierData = await getRediemTierData(rediemToken);
        let currentUserTier = await getCurrentUserTier(rediemTierData);
        function toTitleCase(str) {
            return str.replace(
                /\w\S*/g,
                text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
            );
        }
        document.body.classList.add('rediem-is-logged-in');
        
        let userData = await getCurrentUserData();
        // console.log( '-a-a-as-d-as-das-da-d------12-312-3-213-123-123----', userData )
        let headline = document.querySelector('.section-visibility--loggedin .l2up-headline').textContent;
        document.querySelector('.section-visibility--loggedin .l2up-headline').textContent = headline.replaceAll('[[user]]', userData.data.firstName)
        
        let subheadline_children = document.querySelector('.section-visibility--loggedin .l2up-subheadline').children;
        for (var i = 0; i < subheadline_children.length; i++) {
            let child_text = subheadline_children[i].textContent;
            child_text = child_text.replaceAll('[[user_points]] points', userData.data.rewardPoint + '<span style="font-family:var(--font-sans);text-transform:none;letter-spacing:0;"> points</span>')
            child_text = child_text.replaceAll('[[user_points]]', userData.data.rewardPoint)
            if( rediemTierData ){
                let currentUserTierName = '';
                rediemTierData.data.tiers.forEach( tier => {
                    if( tier.tierTag == userData.data.tierTag ){
                        currentUserTierName = tier.name
                    }
                });
                if( currentUserTierName != '' ){
                    child_text = child_text.replaceAll('[[user_tier]]', '<strong>'+toTitleCase(currentUserTierName)+'</strong>')
                }
            }
            subheadline_children[i].innerHTML = child_text;
        }
    }

    // await unlockUserTiers(currentUserTier);


});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lq--timeline"] && !Shopify.designMode) return;
  try {
    
let timeline_carousel_containers = document.querySelectorAll('.oofos-timeline-section');

timeline_carousel_containers.forEach((carousel_container) => {
	let nextButton = carousel_container.querySelector('.scroll-next');
	let prevButton = carousel_container.querySelector('.scroll-prev');

	let carousel = carousel_container.querySelector('.posts-list');

	/**
	 * Listen for when carousel is either at the beginning or end.
	 * Disable/enable the Next/Prev buttons accordingly.
	 */
	carousel.addEventListener('scroll', () => {
		if (carousel.scrollLeft + 100 > carousel.scrollWidth - carousel.clientWidth) {
			nextButton.setAttribute('disabled', 'disabled');
			prevButton.removeAttribute('disabled');
		} else if (carousel.scrollLeft < 100) {
			nextButton.removeAttribute('disabled');
			prevButton.setAttribute('disabled', 'disabled');
		} else {
			prevButton.removeAttribute('disabled');
			nextButton.removeAttribute('disabled');
		}
	});

	if (nextButton) {
		nextButton.addEventListener('click', function () {
			carousel.scrollLeft += carousel.querySelectorAll('li')[0].clientWidth;
		});
	}
	if (prevButton) {
		prevButton.addEventListener('click', function () {
			carousel.scrollLeft -= carousel.querySelectorAll('li')[0].clientWidth;
		});
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  var videos = document.querySelectorAll('.video--autoplay');
    videos.forEach(video => {
      let video_wrapper = video.closest('.promo-tile__image');
      video.muted = true;
      video.play();
      video.setAttribute('data-state','play');
      video.setAttribute('data-state-reload','false');
      if( video_wrapper ){
        video_wrapper.setAttribute('data-state','play');
        video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state','play');
        video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state-reload','false');
        video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
      }

      if( video_wrapper ){
        let playButton = video_wrapper.querySelector('.video-play-pause');
        if( playButton ){
          playButton.addEventListener('click',function(){
            if (video.paused == true) {
              // Play the video
              video.play();
              video.setAttribute('data-state','play');
              video.setAttribute('data-state-reload','false');
              video_wrapper.setAttribute('data-state','play');

              // Update the button text to 'Pause'
              this.setAttribute('data-button-state','play');
              this.setAttribute('data-button-state-reload','false');
              video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
            } else {
              // Pause the video
              video.pause();
              video.setAttribute('data-state','pause');
              video_wrapper.setAttribute('data-state','pause');

              // Update the button text to 'Play'
              this.setAttribute('data-button-state','pause');
              video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Play video';
            }
          });
        }
      }
    });
    const handleResizeGrid = oofosThrottle( async () => {
        resizeGridPromoTiles();
    }, 100);
    window.addEventListener('resize', handleResizeGrid);

    function resizeGridPromoTiles(){
      let desktopPromoTiles = document.querySelectorAll('.grid__item__large');
      console.log('!! desktopPromoTiles',desktopPromoTiles);

      let list = document.getElementById('product-grid');

      if( window.innerWidth > 767 && window.innerWidth < 1181 ){
        desktopPromoTiles.forEach( (tile,index) => {
          if( tile.getAttribute('data-promo-tile-media-query') && tile.getAttribute('data-promo-tile-media-query') == "desktop") {
            if( index % 2 != 0 ){
              moveItem(list,desktopPromoTiles,index,index+1);
            }
          }
        });
      }
      if( window.innerWidth > 1180 ){
        desktopPromoTiles.forEach( (tile,index) => {
          if( tile.getAttribute('data-promo-tile-media-query') && tile.getAttribute('data-promo-tile-media-query') == "desktop") {
            console.log('index',index)
            if( index % 2 != 0 && index !== 1 ){
              moveItem(list,desktopPromoTiles,index,index-1);
            }
            if( index % 2 === 0 ){
              moveItem(list,desktopPromoTiles,index,index-1);
            }
          }
        });
      }
    }
    const moveItem = (list,items,from, to) => {
      if (to > items.length - 1 || to < 0) return;
      
      const item = items[from];
      if (!item) return;
      
      list.removeChild(item);
      list.insertBefore(item, list.children[to]);
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  var videos = document.querySelectorAll('.video--autoplay');
    videos.forEach(video => {
      let video_wrapper = video.closest('.multicolumn__video');
      video.muted = true;
      video.play();
      video.setAttribute('data-state','play');
      video.setAttribute('data-state-reload','false');
      if( video_wrapper ){
        video_wrapper.setAttribute('data-state','play');
        video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state','play');
        video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state-reload','false');
        video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
      }

      if( video_wrapper ){
        let playButton = video_wrapper.querySelector('.video-play-pause');
        if( playButton ){
          playButton.addEventListener('click',function(){
            if (video.paused == true) {
              // Play the video
              video.play();
              video.setAttribute('data-state','play');
              video.setAttribute('data-state-reload','false');
              video_wrapper.setAttribute('data-state','play');

              // Update the button text to 'Pause'
              this.setAttribute('data-button-state','play');
              this.setAttribute('data-button-state-reload','false');
              video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
            } else {
              // Pause the video
              video.pause();
              video.setAttribute('data-state','pause');
              video_wrapper.setAttribute('data-state','pause');

              // Update the button text to 'Play'
              this.setAttribute('data-button-state','pause');
              video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Play video';
            }
          });
        }
      }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    let menu_btn = document.getElementById('mobile-menu-btn');
    menu_btn.addEventListener('click',function(){
        document.body.classList.toggle('mobile-menu-open')
    });

    let locale_picker = document.querySelector('.promo-bar__linklist-item.promo-bar__linklist-item--locale');
    let locale_picker_clone = locale_picker.cloneNode(true);
    let locale_picker_mobile_item = document.getElementById('mobile-locale-picker');
    locale_picker_mobile_item.append(locale_picker_clone);

    let localePickerButton = document.getElementById('mobile-locale-picker');

    localePickerButton.addEventListener('click',function(){
        document.querySelector('#locale-modal').showModal();
    });

    let sparkle_buttons = document.querySelectorAll('.menu-item-sparkles');
    if( sparkle_buttons && sparkle_buttons.length > 0 ){
      sparkle_buttons.forEach(menu_item => {
        menu_item.classList.add('animate-in');
      })
    }
});
document.addEventListener("DOMContentLoaded", async () => {
    let mobileRewardsButton = document.getElementById('mobile-nav-open-rewards');
    if( mobileRewardsButton ){
      mobileRewardsButton.addEventListener('click',function(){
          let rippleButton = document.getElementById('ripplFectButton');
          if( rippleButton ){
              rippleButton.click();
          }
      });
    }

    let colorElement = document.querySelector('[data-new-nav-bg-color]');
    let color;
    if( colorElement ){
        color = colorElement.getAttribute('data-new-nav-bg-color');
        document.querySelector('.navbar-desktop__wrapper').style.setProperty('background-color', color);
    }

    document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
    async function getRediemUserSessionStorageOofos(){
        let userData = sessionStorage.getItem('user_www.oofos.com');
        if( !userData ) return;
        let userDataJSON = JSON.parse(userData);
        return userDataJSON;
    }
    async function getBearerTokenOofos(){
        let userDataJSON = await getRediemUserSessionStorageOofos()
        if( !userDataJSON || !userDataJSON.data || !userDataJSON.data.token ) return;
        return userDataJSON.data.token;
    }
    async function getRediemTierDataOofos(token){
        let data = await fetch('https://api.rediem.io/api/dash/tiers', { 
            method: 'GET', 
            headers: new Headers({
                'Authorization': 'Bearer '+token, 
                'Content-Type': 'application/json'
            }),
        }).then( response => {
            return response.json();
        });
        if( data && data.success == true) {
            return data;
        }else{
            return;
        }
    }
    async function getCurrentUserTierOofos(rediemTierData) {
        let userData = await getRediemUserSessionStorageOofos();
        if( !userData.data ) return;
        let userTierId = userData.data.activeTier;
        if( !userTierId ) return;

        let rediemTiers = rediemTierData.data.tiers;

        let currentTierName;
        let currentTierIndex;
        rediemTiers.forEach( (tier,index) => {
            if( tier._id === userTierId ) {
                currentTierName = tier.name
                currentTierIndex = index;
            }
        });
        if( currentTierName ) {
            return {index: currentTierIndex, name: currentTierName.toUpperCase()};
        }
    }
    async function getCurrentUserData(){
        return await getRediemUserSessionStorageOofos();
    }
    let rediemToken = await getBearerTokenOofos();
    let rediemTierData;
    let currentUserTier;

    if( !rediemToken ) {
    }else{
      rediemTierData = await getRediemTierDataOofos(rediemToken);
      currentUserTier = await getCurrentUserTierOofos(rediemTierData);
      let userData = await getCurrentUserData();
      if( userData && userData != null ) {
          let pointBalances = document.querySelectorAll('.swell-point-balance');
          pointBalances.forEach(balance => {
              balance.textContent = (userData.data.rewardPoint ?? 0) + ' points';
          })
      }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp--compare"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", async () => {
        const mutationCallback = async (mutationsList) => {
            let data_attribute = "data-current-pseudo-variant-product-handle"
            let current_title = document.getElementById('pdp-compare--title');
            let current_title_text;
            if( current_title ){
                current_title_text = current_title.textContent ?? '';
            }
            let current_desc = document.getElementById('pdp-compare--description');
            let current_desc_text;
            if( current_desc ){
                current_desc_text = current_desc.innerHTML;
            }
            for (const mutation of mutationsList) {
                if (
                mutation.type !== "attributes" ||
                mutation.attributeName !== "data-current-pseudo-variant-product-id"
                ) {
                return
                }
                let new_value = mutation.target.getAttribute("data-current-pseudo-variant-product-handle");
                let new_id = mutation.target.getAttribute('data-current-pseudo-variant-product-id');
                if ( new_value && new_value != null ) {
                    let items = document.querySelectorAll('.pdp-compare__products__item');
                        items.forEach(el => el.classList.add('skeleton-loader'))
                    if( document.querySelector('.shopify-section.section[id*="__pdp_compare_"]') ){
                        let new_content = await fetch(window.Shopify.routes.root + 'products/'+new_value+'/?sections=pdp--compare').then(res => res.json())
                        .then(z => {
                            document.querySelector('.shopify-section.section[id*="__pdp_compare_"]').innerHTML = z['pdp--compare'];
                            let new_current_title = document.getElementById('pdp-compare--title');
                            if( new_current_title ){
                                new_current_title.innerHTML = current_title_text;
                            }
                            let new_current_desc = document.getElementById('pdp-compare--description');
                            if( new_current_desc ){
                                new_current_desc.innerHTML = current_desc_text;
                            }
                            
                            window.$forcePDPCompareTilesUpdate();
                        });
                    }
                    let new_dialog_content = await fetch(window.Shopify.routes.root + 'products/'+new_value+'/?sections=product-form-dialog').then(res => res.json())
                        .then( y => {
                            // console.log('y',y)
                            document.getElementById('dialog1').querySelector('.dialog_content').innerHTML = y['product-form-dialog'];
                            return y;
                        });
                }else{
                    let items = document.querySelectorAll('.pdp-compare__products__item');
                        items.forEach(el => el.classList.remove('skeleton-loader'))
                }
            }
        }
        
        const observer = new MutationObserver(mutationCallback)
        // let productDisplayWrapper = document.querySelector('.product-display-wrapper');
        
        // observer.observe(productDisplayWrapper, { attributes: true })

        function addObserverIfDesiredNodeAvailable() {
            var composeBox = document.querySelector('.product-display-wrapper');
            if(!composeBox) {
                //The node we need does not exist yet.
                //Wait 500ms and try again
                window.setTimeout(addObserverIfDesiredNodeAvailable,500);
                return;
            }
            // var config = {childList: true};
            observer.observe(composeBox, { attributes: true })
        }
        addObserverIfDesiredNodeAvailable();
    // };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp--video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  var videos = document.querySelectorAll('.video--autoplay');
    videos.forEach(video => {
      let video_wrapper = video.closest('.plp-video__video');
      video.muted = true;
      video.play();
      video.setAttribute('data-state','play');
      video.setAttribute('data-state-reload','false');
      if( video_wrapper ){
        video_wrapper.setAttribute('data-state','play');
        video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state','play');
        video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state-reload','false');
        video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
      }

      if( video_wrapper ){
        let playButton = video_wrapper.querySelector('.video-play-pause');
        if( playButton ){
          playButton.addEventListener('click',function(){
            if (video.paused == true) {
              // Play the video
              video.play();
              video.setAttribute('data-state','play');
              video.setAttribute('data-state-reload','false');
              video_wrapper.setAttribute('data-state','play');

              // Update the button text to 'Pause'
              this.setAttribute('data-button-state','play');
              this.setAttribute('data-button-state-reload','false');
              video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
            } else {
              // Pause the video
              video.pause();
              video.setAttribute('data-state','pause');
              video_wrapper.setAttribute('data-state','pause');

              // Update the button text to 'Play'
              this.setAttribute('data-button-state','pause');
              video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Play video';
            }
          });
        }
      }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    loadLocally();
    function accordionsMoveLocally() {
        // move Locally
          const locallyButton = document.querySelector('.lcly-container');
          const newLocalContainer = document.getElementById('local-box');
          let localButton = document.getElementById('lcly-button-0');
  
          if (locallyButton) {
            newLocalContainer.appendChild(locallyButton);
          }
          if( localButton ){
            //   console.log('localButton',localButton)
              localButton.removeAttribute('tabindex');
          }
    }
    // document.getElementById('lcly-button-0').addEventListener('click',function(e){
    //     console.log('e',e)
    //     console.log('this',this)
    // });
    const openDetailsIfAnchorHidden = (evt) => {
        // const target = evt.currentTarget.getAttribute("href"); // "#anchored"
        // if( !target || target.length < 2 ) return;
        // const elTarget = document.querySelector(target);

        // if (!elTarget) return; // No such element in DOM. Do nothing
        // if (elTarget.offsetHeight > 0 || elTarget.getClientRects().length) return; // Already visible

        // Open all <details> ancestors
        let elTarget = document.getElementById('product-details');
        let elDetails = elTarget.closest("details");
        while (elDetails) {
            if (elDetails.matches("details")) elDetails.open = true;
            elDetails = elDetails.parentElement;
        }
        elTarget.scrollIntoView();
    }

    document.querySelector('.view-product-details').addEventListener('click',function(e){
        e.preventDefault();
        openDetailsIfAnchorHidden(e);
    });
    
    window.addEventListener('load', function() {
         if ( window.location.hash === "#reviews" ) {
            setTimeout(function(){
                scrollToReviews();
            },10);
        }
        // document.querySelectorAll("[href$='#product-details']").forEach((el) => {
        //     el.addEventListener("click", openDetailsIfAnchorHidden);
        // });
        document.querySelectorAll("[href$='#reviews']").forEach((el) => {
            el.addEventListener("click", scrollToReviews);
        });
        
        function scrollToReviews(e){
            if( e ) e.preventDefault();
            let reviewsSection = document.querySelector('.yotpo-widget-instance');
            reviewsSection.scrollIntoView();
        }
        const el = document.querySelector(".product-form__atc")
        if( el ){
            const rect = el.getBoundingClientRect();
            const topFromViewport = rect.top;
            const topFromDocument = rect.top + window.scrollY; // For position relative to the document
        }

        let more_payment_options = document.querySelector('.more_payment_options');
        if( more_payment_options ){
            more_payment_options.addEventListener('click',function() {
                let form = more_payment_options.closest('form');
                
                let sizes = form.querySelector('.product-form__options').querySelector('.product-form__option1').querySelectorAll('.option-select__label');

                let has_size_selection = false;
                sizes.forEach( size => {
                    if( size.classList.contains('option-select__label--selected') ){
                        let value = size.querySelector('input').value;

                        if( value ){
                            has_size_selection = true;
                            let dialog = document.getElementById('dialog1');
                            let sizeSelector = dialog.querySelector('select[name="id"]');
                            let sizeSelectorChosen = dialog.querySelector('option[data-size-no="'+value+'"]');
                            sizeSelector.value = sizeSelectorChosen.value;
                        }
                    }
                });
                if( !has_size_selection ) return;
                let dialog_layer = document.getElementById('dialog_layer');
                let dialog1 = document.getElementById('dialog1');
                dialog_layer.classList.remove('hidden');
                dialog1.classList.remove('hidden');
            });
        }
        setTimeout(function(){
            accordionsMoveLocally()
        },1000)
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
window.addEventListener("load", async function(event) { 

  let grid_carousels = document.querySelectorAll('.grid-carousel');

  grid_carousels.forEach( carousel => {
    let related_products = carousel.closest('.related-products');
    let nextButton = related_products.querySelector('.scroll-next');
    let prevButton = related_products.querySelector('.scroll-prev');

    /**
    * Listen for when carousel is either at the beginning or end.
    * Disable/enable the Next/Prev buttons accordingly.
    */
    carousel.addEventListener('scroll', () => {
      if (carousel.scrollLeft + 100 > carousel.scrollWidth - carousel.clientWidth) {
        nextButton.setAttribute('disabled', 'disabled');
        prevButton.removeAttribute('disabled');
      } else if (carousel.scrollLeft < 100) {
        nextButton.removeAttribute('disabled');
        prevButton.setAttribute('disabled', 'disabled');
      } else {
        prevButton.removeAttribute('disabled');
        nextButton.removeAttribute('disabled');
      }
    });

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        carousel.scrollLeft += carousel.querySelectorAll('li')[0].clientWidth;
      });
    }
    if (prevButton) {
      prevButton.addEventListener('click', function () {
        carousel.scrollLeft -= carousel.querySelectorAll('li')[0].clientWidth;
      });
    }
  });

  await fieldset_swatches();
  await initQuickAdd();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soldout--popup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
    let quickViewButtonsText = document.querySelectorAll('.subheadline-link[href*="javascript"]');
    let quickViewButtons = document.querySelectorAll('.button.product-tile__quick-view-cta');
    quickViewButtons.forEach(z => {
        z.addEventListener('click',function(e){
            setTimeout(function(){
                showSoldout();
            },500);
        })
    });
    quickViewButtonsText.forEach(z => {
        z.addEventListener('click',function(e){
            setTimeout(function(){
                showSoldout();
            },500);
        })
    });
})

function showSoldout() {
    let sizeSwatchesContainer = document.querySelector('.product-form__option1');

    let swatches = sizeSwatchesContainer.querySelectorAll('.option-select__label');

    let list = sizeSwatchesContainer.querySelector('.option-select__label-list');
    list.classList.add('soldout');

    if ( Array.from(swatches).every(child => child.classList.contains("option-select__label--out-of-stock"))) {
      let soldoutBox = document.createElement('div');
      soldoutBox.innerHTML = 'This exclusive product has sold out, <u>sign up to get early access</u> to future OOFOS collabs';
      soldoutBox.classList.add('soldoutbox');

      list.append(soldoutBox);

      soldoutBox.addEventListener('click', function (){
          window._klOnsite = window._klOnsite || []; 
          window._klOnsite.push(['openForm', 'Tpytwk']);
      });
    }
}

  } catch(e) { console.error(e); }
})();
})();
